var exports = {
  "jw": "x93eb46d8--662637--chip",
  "kl": "x93eb46d8--662637--chip_button",
  "Kk": "x93eb46d8--662637--icon",
  "$w": "x93eb46d8--662637--chip_redesign",
  "Ld": "x93eb46d8--662637--chip_redesign_selected",
  "M2": "x93eb46d8--662637--icon_redesign",
};

module.exports = exports;
